import { fetchApiHub } from 'frontastic/lib/fetch-api-hub';

export const getInsuranceConfiguration = async () => {
  return await fetchApiHub('/action/project/getInsuranceConfiguration');
};

export const getSiteLinksConfiguration = async () => {
  return await fetchApiHub('/action/project/getSiteLinksConfiguration');
};

export const getOpenGraphData = async () => {
  return await fetchApiHub('/action/project/getOpenGraphData');
};
